"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withSetMulti;
function withSetMulti(fn) {
  return function (model) {
    var props = model.props();

    return [model.setMulti(fn(props))];
  };
}